import { render, staticRenderFns } from "./GrindOrderLoader.vue?vue&type=template&id=533a87d6"
import script from "./GrindOrderLoader.vue?vue&type=script&lang=js"
export * from "./GrindOrderLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports